import { Link } from "react-router-dom"
import { useLanguage } from '../i18n/LanguageContext'

const Footer = () => {
  const { lang } = useLanguage()

  return (
    <footer className="footer">
      <div className="footer_content">
        <Link to='/privacybeleid'><p>{lang === 'nl' ? 'Privacybeleid' : 'Privacy Policy'}</p></Link>
        <p>&copy; Parking Haarlem - {new Date().getFullYear()}</p>
      </div>
    </footer>
  )
}

export default Footer
